import React from 'react';
import { Modal, Alert, Text, Group, Button } from '@mantine/core';
import { MODAL_SIZES } from '../../theme/mantineTheme';

export interface EnumeratedSetManualMemberBlockedModalProps {
    open: boolean;
    onClose: () => void;
}

/** Shown when user tries to add ManualSetMember on an Enumerated Set. */
export const EnumeratedSetManualMemberBlockedModal: React.FC<EnumeratedSetManualMemberBlockedModalProps> = ({
    open,
    onClose,
}) => (
    <Modal opened={open} onClose={onClose} title="Manual members not allowed" size={MODAL_SIZES.confirm}>
        <Alert color="yellow">
            <Text size="sm">
                This Set is <strong>Enumerated</strong>. You can&apos;t add manual members. Switch the Set type to{' '}
                <strong>Manual</strong> to add members.
            </Text>
        </Alert>
        <Group justify="flex-end" mt="md">
            <Button onClick={onClose}>Close</Button>
        </Group>
    </Modal>
);
